import type { ComponentChildren } from 'preact';
import styles from './Alert.module.css';

interface AlertProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
  children: ComponentChildren;
}

export function Alert({ variant = 'info', children }: AlertProps) {
  return <div className={`${styles.alert} ${styles[variant]}`}>{children}</div>;
}
